export const SET_ORG_TOTAL_COUNT = 'setOrgTotalCount'
export const SET_TITLE_TOTAL_COUNT = 'setTitleTotalCount'
export const INIT_ORGS = 'initOrgs'
export const INIT_TITLES = 'initTitles'
export const SPLICE_ORGS = 'spliceOrgs'
export const SPLICE_TITLES = 'spliceTitles'
export const CLEAR_ORGS = 'clearOrgs'
export const CLEAR_TITLES = 'clearTitles'
